// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hI15","content":"styles_content__3_fTZ"};